import { useApolloClient } from "@apollo/client";
import { get, uniq } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { COLLECTIVE_PLAN_COVERAGES } from "utils/api/graphql/queries/collective-quotes";
import { withoutNil } from "./helpers";

const useCoveragePlans = (planIds) => {
  const client = useApolloClient();
  const [plansById, setPlansById] = useState({});
  const [failed, setFailed] = useState(false);
  const idsKey = uniq(withoutNil(planIds)).sort().join(",");
  const ids = useMemo(() => (idsKey ? idsKey.split(",") : []), [idsKey]);

  useEffect(() => {
    let active = true;
    Promise.all(
      ids.map((id) =>
        client.query({
          query: COLLECTIVE_PLAN_COVERAGES,
          variables: { where: { id } },
        }),
      ),
    )
      .then((results) => {
        if (!active) return;
        setFailed(false);
        setPlansById(
          Object.fromEntries(
            results.map(({ data }) => [
              get(data, "insurancePlan.id"),
              get(data, "insurancePlan"),
            ]),
          ),
        );
      })
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
    };
  }, [client, ids]);

  const plans = useMemo(
    () => ids.map((id) => plansById[id]).filter(Boolean),
    [ids, plansById],
  );
  return { plans, plansById, failed };
};

export default useCoveragePlans;
